import * as req from '_common/utils/req';

import URL from '../constants/URL';
import dataProxy from '../dataProxy';

export default {
  /**
   * 获取kyc 信息
   * @returns {Promise<any>}
   */
  getKycInfo(params) {
    return new Promise((resolve, reject) => {
      dataProxy
        .get(URL.GET_KYC_INFOS, {
          params,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },

  /**
   * 获取kyc国家列表
   * @returns {Promise<any>}
   */
  getKycCountry(params) {
    return new Promise((resolve, reject) => {
      dataProxy
        .get(URL.GET_KYC_COUNTRYLIST, { params })
        .then((res) => {
          resolve(res.data);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },

  /**
   * 获取kyc国家列表
   * @returns {Promise<any>}
   */
  getResidenceList(params) {
    return new Promise((resolve, reject) => {
      dataProxy
        .get(URL.GET_KYC_PROVINCELIST.replace('{0}', 'US'), { params })
        .then((res) => {
          resolve(res.data);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },

  /**
   * 获取认证等级权限
   * @returns {Promise<any>}
   */
  getKycLimits(params) {
    return new Promise((resolve, reject) => {
      dataProxy
        .get(URL.GET_KYC_KYCLIMITS, { params })
        .then((res) => {
          resolve(res.data);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },

  /**
   * face++获取二维码
   * @returns {Promise<any>}
   */
  getFaceQRCode(params) {
    return new Promise((resolve, reject) => {
      dataProxy
        .postForm(URL.GET_KYC_GETFACEURL, params)
        .then((res) => {
          resolve(res);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },

  /**
   * 获取绑卡接口
   * @returns {Promise<any>}
   */
  getKycCurrent(params) {
    return new Promise((resolve, reject) => {
      dataProxy
        .get(URL.GET_KYC_CURRENT, params)
        .then((res) => {
          resolve(res.data);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },

  /**
   * 获取资金各级别权益
   * @returns {Promise<any>}
   */
  getBalanceLimit(params) {
    return new Promise((resolve, reject) => {
      dataProxy
        .get(URL.BALANCE_KYC_LIMIT, params)
        .then((res) => {
          resolve(res.data);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },

  /**
   * 获取资金各级别权益
   * @returns {Promise<any>}
   */
  getKycDownload(params) {
    return new Promise((resolve, reject) => {
      dataProxy
        .get(URL.GET_KYC_ENTERPRISESAMPLE, params)
        .then((res) => {
          resolve(res.data);
        })
        .catch((res) => {
          reject(res);
        });
    });
  },

  /**
   * 获取国籍列表
   * @returns {Promise<*>}
   */
  async getKycCountryNew() {
    const params = {
      type: 3,
    };
    const res = await req.getAsync(URL.GET_KYC_DICTIONARY, params);
    return res;
  },

  /**
   * 根据邮编获取省市区街道
   * @returns {Promise<*>}
   */
  async getAddressByPostCode(params) {
    const res = await req.getAsync(URL.GET_KYC_ADDRESSLIST, params);
    return res;
  },

  /**
   * 提交个人基本信息页面数据
   * @returns {Promise<*>}
   */
  async saveBassInfo(params) {
    const res = await req.postAsync(URL.GET_KYC_SAVE_FIRST, params);
    return res;
  },

  /**
   * 提交监护人页面数据
   * @returns {Promise<*>}
   */
  async saveGuardian(params) {
    const res = await req.postAsync(URL.POST_KYC_SAVE_GUARDIAN, params);
    return res;
  },

  /**
   * 企业基本信息保存
   * @param params
   * @returns {Promise<*>}
   */
  async saveCompanyBaseInfo(params) {
    const res = await req.postAsync(URL.GET_KYC_SAVE_FIRST_CORP, params);
    return res;
  },
  /**
   * 获取监护人信息
   * @returns {Promise<*>}
   */
  async getGuardianInfo(type) {
    const res = await req.getAsync(`${URL.GET_KYC_GUARDIAN}/${type}`);
    return res;
  },

  /**
   * 获取初始化信息
   * @returns {Promise<*>}
   */
  async getInitInfo(type) {
    const res = await req.getAsync(`${URL.GET_KYC_INIT_INFO}/${type}`);
    return res;
  },

  /**
   * 获取初始化信息v2
   * @returns {Promise<*>}
   */
  async getInitInfoV2() {
    const res = await req.getAsync(`${URL.GET_KYC_INIT_INFO_V2}`);
    return res;
  },

  /**
   * 获取再kyc状态
   * @returns {Promise<*>}
   */
  async getRekycInfo() {
    const res = await req.getAsync(`${URL.GET_REKYC_INFO}`);
    return res;
  },

  /**
   * 再kyc变更确认
   * @returns {Promise<*>}
   */
  async updateRekycInfo(params) {
    const res = await req.postAsync(`${URL.UPDATE_REKYC_INFO}`, params);
    return res;
  },

  /**
   * 获取初始化信息v2 for 法人
   * @returns {Promise<*>}
   */
  async getInitInfoV2Corp() {
    const res = await req.getAsync(`${URL.GET_KYC_INIT_INFO_V2_CORP}`);
    return res;
  },

  /**
   * 获取是否可以使用ekyc及其类型
   * @returns {Promise<*>}
   */
  async getEkycConfig() {
    const res = await req.getAsync(URL.GET_EKYC_CONFIG);
    return res;
  },

  /**
   * 检查用户是否还需要做EKYC
   * @returns {Promise<*>}
   */
  async checkEkycStatus() {
    const res = await req.getAsync(URL.CHECK_EKYC_STATUS);
    return res;
  },

  /**
   * 获取QR Code ID用于生成二维码
   * @returns {Promise<*>}
   */
  async getEkycQRCode() {
    const res = await req.getAsync(URL.GET_EKYC_QRCODE);
    return res;
  },

  /**
   * 校验QR Code ID
   * @returns {Promise<*>}
   */
  async checkEkycQRCode(qId) {
    const res = await req.postAsync(URL.CHECK_EKYC_QRCODE, { qId });
    return res;
  },

  /**
   * 获取企业基本信息
   * @returns {Promise<*>}
   */
  async getCompanyBaseInfo(type) {
    const res = await req.getAsync(`${URL.GET_KYC_COMPANY_INFO_FIRST}/${type}`);
    return res;
  },

  /**
   * 获取kyc1信息
   * @returns {Promise<*>}
   */
  async getBaseInfo(type) {
    const res = await req.getAsync(`${URL.GET_KYC_INFO_FIRST}/${type}`);
    return res;
  },

  /**
   * 获取kyc1信息 - 个人
   * @returns {Promise<*>}
   */
  async getBaseInfoPersonal(type) {
    const res = await req.getAsync(`${URL.GET_KYC_INFO_FIRST_PERSON}`, {
      type,
    });
    return res;
  },

  /**
   * 获取kyc1信息 - 法人
   * @returns {Promise<*>}
   */
  async getBaseInfoCorp(type) {
    const res = await req.getAsync(`${URL.GET_KYC_INFO_FIRST_CORP}`, {
      type,
    });
    return res;
  },

  /**
   * get person career
   * @returns {Promise<*>}
   */
  async getPersonCareer() {
    const params = {
      type: 4,
      id: 0,
    };
    const res = await req.getAsync(URL.GET_KYC_DICTIONARY, params);
    return res;
  },

  /**
   * get company career
   * @returns {Promise<*>}
   */
  async getCompanyCareer() {
    const params = {
      type: 2,
      id: 0,
    };
    const res = await req.getAsync(URL.GET_KYC_DICTIONARY, params);
    return res;
  },

  /**
   * Get InsiderCoinList from DB
   */

  async getInsiderCoinList() {
    const { isUnifiedAccount } = window.okGlobal;
    const res = await req.getAsync(
      isUnifiedAccount ? URL.GET_CURRENCIES_LIST_V2 : URL.GET_CURRENCIES_LIST
    );
    return res;
  },

  /**
   * Get CARF Info
   * @returns {Promise<import('_pages/account/carfForm/types.ts').CarfInfoResponse>}
   */
  async getCarf() {
    const res = await req.getAsync(URL.GET_CARF_INFO);
    return res;
  },

  /**
   * Submit CARF Notification Form
   * @param params
   * @returns {Promise<*>}
   */
  async submitCarf(params) {
    const res = await req.postAsync(URL.POST_CARF_SUBMIT, params);
    return res;
  },

  /**
   * 查询用户用于提交carf的kyc信息
   * @returns {Promise<import('_pages/account/carfForm/types.ts').KycInfoForCarfResponse>}
   */
  getCarfKycInfo() {
    return req.getAsync(URL.GET_CARF_KYCINFO);
  },

  /**
   * Get CARF dictionaries (countries and entity types)
   * @returns {Promise<import('_pages/account/carfForm/types.ts').CarfDictResponse>}
   */
  async getCarfDict() {
    const res = await req.getAsync(URL.GET_CARF_DICT);
    return res;
  },
};
